export default __webpack_public_path__ + "static/elTorito-44dfb6ee0fa231eb2bea161b8d977740.svg";